import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useUpdateWeighBillStatus } from "hooks/useWeighBill";
import { toast } from "react-toastify";

export const UpdateWeighbillStatus = ({ isOpen, toggle, editDetails }) => {
  const [status, setStatus] = useState(editDetails?.status);
  const { mutate: updateStatus, isPending } = useUpdateWeighBillStatus();

  if (!editDetails) {
    return null;
  }

  const handleSubmit = () => {
    editDetails.status = status || editDetails.status;
    const payload: any = {
      id: editDetails.id,
      status: editDetails.status,
    };

    updateStatus(
      { id: payload.id, data: payload },
      {
        onSuccess: () => {
          toggle();
          toast.success("Weighbill status updated successfully.");
          resetForm();
        },
      }
    );
  };

  const handleCancel = () => {
    setStatus("");
    toggle();
  };

  const resetForm = () => {
    setStatus("");
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={handleCancel}>Update Weigh Bill Status</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="product_transfer_status">Status</Label>
          <Input
            id="weighbill_status"
            name="weighbill_status"
            value={status || editDetails.status}
            type="select"
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Select status"
            required
          >
            {editDetails.status !== "approved" && (
              <option value="draft" key="1">
                Draft
              </option>
            )}
            <option value="in review" key="2">
              In review
            </option>
            {editDetails.status !== "draft" && (
              <option value="approved" key="3">
                Approved
              </option>
            )}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={isPending}>
          {isPending ? "Updating..." : "Update"}
        </Button>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
